import { GET_INTERNATIONAL_PAYMENT_TERM_REQUEST, GET_INTERNATIONAL_PAYMENT_TERM_SUCCESS, GET_INTERNATIONAL_PAYMENT_TERM_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalPaymentTerm = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_PAYMENT_TERM_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalPaymentTerm`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_PAYMENT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_PAYMENT_TERM_ERROR,
                payload: error.response,
            });
        })
}

